import { render } from "./SessionPointsList.vue?vue&type=template&id=34fb2480&scoped=true"
import script from "./SessionPointsList.vue?vue&type=script&lang=js"
export * from "./SessionPointsList.vue?vue&type=script&lang=js"

import "./SessionPointsList.vue?vue&type=style&index=0&id=34fb2480&lang=scss&scoped=true"

import exportComponent from "/home/esesja/domains/app.esesja.mda.pl/public_html/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34fb2480"]])

export default __exports__